export const baseImageURL = "";

export const addNewSchoolURL = "/api/schools";

export const getAllSchoolsURL = "/api/schools";

export const getClassesForSchoolURL = "/api/getClassesForSchool";

export const getAllMaterialsURL = "/api/getAllMaterials";

export const addMaterialURL = "/api/addMaterial";

export const deleteMaterialURL = "/api/deleteMaterial";

export const addMaterialsToClassURL = "/api/addMaterialsToClass";

export const getAllClassesURL = "/api/getAllClasses";

export const addClassesToSchoolURL = "/api/addClassesToSchool";

export const addSectionToClassURL = "/api/addSectionToClass";

export const getParentsForSchoolURL = "/api/getParentsForSchool";

export const createParentForSchoolURL = "/api/createParentData";

export const getStudentsForSchoolURL = "/api/getStudentsForSchool";

export const addStudentForSchoolURL = "/api/students";

export const deleteStudentURL = "/api/students";

export const getAdsForSchoolURL = "/api/getAds";

export const getGlobalAdURL = "/api/getGlobalAd";

export const addNewAdsForSchoolURL = "/api/addNewAd";

export const deleteAdsURL = "api/deleteAd";

export const getStudentsForSectionURL = "/api/getStudentsForSection";

export const getWeeklyClassesForSectionURL = "/api/getWeeklyClassesForSection";

export const getParentNotesURL = "/api/parent-notes";

export const getSchoolNotesURL = "/api/school-notes";

export const getSchoolInfoURL = "/api/schools";

export const getDaysOfWeekURL = "/api/getDaysOfWeek";

export const getMaterialsForClassURL = "/api/getMaterialsForClassDashboard";

export const addTimeSlotURL = "/api/addTimeSlot";

export const getSectionsForClassURL = "api/getSectionsForClass";

export const deleteTimeSlotURL = "/api/deleteTimeSlot";

export const addImageToSchoolURL = "/api/addImageToSchool";

export const getTeachersForSchoolURL = "api/getTeachersForSchool";

export const addTeacherForSchoolURL = "/api/teachers";

export const searchStudentURL = "/api/searchStudent";

export const editStudentURL = "/api/editStudent";

export const showGradesForAllMaterialsURL = "/api/showGradesForAllMaterials";

export const addNewGradeURL = "/api/addNewGrade";

export const deleteTeacherURL = "/api/teachers";

export const deleteTeacherSessionURL = "/api/teacherSessions";

// export const deleteParentDataURL = '/api/deleteParentData'
export const deleteParentDataURL = "api/deleteParentUser";

export const AddNewSecretaryURL = "/api/createSecretary";

export const getSchoolSecretaryAccountsURL = "/api/getSchoolSecretaryAccounts";

export const getStudentsForParentURL = "/api/getStudentsForParent";

export const editParentDataURL = "/api/editParentData";

export const sendNotificationToParentsURL="/api/sendNotificationToParents"

export const checkNewNotificationsURL="/api/checkNewNotifications"

export const getParentDataURL = "/api/getParentData";

export const editTeachersURL = "/api/teachers";

export const getSendingNoteFromSchoolURL = "/api/getAllSchoolNotes";

export const editSchoolURL = "/api/editSchool";

export const getAllStudentsURL = "/api/students";

export const editSectionURL = "/api/editSection";

export const getStudentPaymentsURL = "/api/getPaymentRemain";

export const getPointsForSectionStudentsURL = "/api/points";

export const addPointsForStudentsURL = "/api/points";

export const deleteStudentPaymentURL = "api/deletePayment";

export const addStudentPaymentURL = "/api/createPayment";

export const deleteGrade = "/api/deleteGrade";

export const addPoints = "/api/points";

export const getTestGradesForSectionURL = "api/getTestGradesForSection";

export const examFormsURL = "/api/exam_forms";

export const addQuestionURL = "/api/exam_forms/addQuestion";

export const deleteQuestionURL = "/api/exam_forms/deleteQuestion";

export const ministerialDecisionsURL = "/api/ministerialDecisions";

export const addSessionsTeacherURL = "/api/teacherSessions";

export const getTeacherSessionsrURL = "/api/teacherSessions";

export const addQuestionImageURL = "/api/exam_forms/addQuestionImage";

export const getJalaaURL = "/api/getJalaa";
